import React, { useRef } from 'react';
var VeltActivityLogHeaderFilterContentItem = function (props) {
    var defaultCondition = props.defaultCondition, filterOption = props.filterOption, isActive = props.isActive, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-activity-log-header-filter-content-item", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined, "filter-option": filterOption, "is-active": [true, false].includes(isActive) ? (isActive ? 'true' : 'false') : undefined }, children));
};
export default VeltActivityLogHeaderFilterContentItem;
